import { iots } from '@code-expert/pfs/dist/prelude';
import { adt, eq, string } from '@code-expert/prelude';

const orderKeys = {
  manual: null,
  random: null,
};

export const QuizSettingOrderC = iots.keyof(orderKeys);
export type QuizSettingOrder = iots.TypeOf<typeof QuizSettingOrderC>;

export const foldQuizSettingOrder = adt.foldFromKeys(orderKeys);

//--------------------------------------------------------------------------------------------------

const feedbackKeys = {
  immediate: null,
  date: null,
  never: null,
};

export const QuizSettingFeedbackC = iots.keyof(feedbackKeys);
export type QuizSettingFeedback = iots.TypeOf<typeof QuizSettingFeedbackC>;

export const foldQuizSettingFeedback = adt.foldFromKeys(feedbackKeys);

//--------------------------------------------------------------------------------------------------

const attemptsKeys = {
  unlimited: null,
  first: null,
  editable: null,
};

export const QuizSettingAttemptsC = iots.keyof(attemptsKeys);
export type QuizSettingAttempts = iots.TypeOf<typeof QuizSettingAttemptsC>;

export const foldQuizSettingAttempts = adt.foldFromKeys(attemptsKeys);

//--------------------------------------------------------------------------------------------------

const quizSettings = {
  order: QuizSettingOrderC,
  feedback: QuizSettingFeedbackC,
  attempts: QuizSettingAttemptsC,
};

export const QuizSettingsC = iots.strict(quizSettings);
export type QuizSettings = iots.TypeOf<typeof QuizSettingsC>;

export const defaultQuizSettings: QuizSettings = {
  order: 'manual',
  feedback: 'immediate',
  attempts: 'first',
};

export const quizSettingsEq: eq.Eq<QuizSettings> = eq.strict({
  order: string.Eq,
  feedback: string.Eq,
  attempts: string.Eq,
});
